import { createContext, useContext, useState } from 'react'

type FundsEntry = {
  inputType: 'fund' | 'shareclass' | 'bucket'
  currency: 'gbp' | 'usd' | 'eur' | 'jpy' | 'cad' | 'chf'
  name: string
  longName: string
  platform: string
}

export const useCreateFundsContext = () => {
  const [newEntry, setNewEntry] = useState<FundsEntry | null>(null)
  const [isDownloadingPDF, setIsDownloadingPDF] = useState(false)

  const createNewEntry = (fromData?: Partial<FundsEntry>) => {
    setNewEntry({
      inputType: 'fund',
      currency: 'gbp',
      name: '',
      longName: '',
      platform: '',
      ...fromData,
    })
  }

  return {
    newEntry,
    setNewEntry,
    createNewEntry,
    isDownloadingPDF,
    setIsDownloadingPDF,
  }
}

export const fundsContext = createContext<ReturnType<typeof useCreateFundsContext> | null>(null)

export const useFundsContext = () => {
  const context = useContext(fundsContext)
  if (!context) throw new Error('Ops Context must be used within an Ops Context Provider.')
  return context
}
